import React from "react";
import Navbar from "../components/Navbar.jsx";

const Layout = ({ children }) => {
  return (
    <div className=" bg-[#FDE3D9] h-screen w-full relative overflow-hidden">
      <Navbar />
      {children}
    </div>
  );
};

export default Layout;